import React, { useEffect, useMemo, useRef, useState } from 'react';
import Views from '@components/StoreCubby/Views';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getObjectValue } from '@utility/utills';
import {
  parseCheck,
  getAllSelectedChecks,
  getDueTime,
} from '../Fireboard/common';
import {
  getElapsedTimeInMs,
  getDeliverTo,
  getCubbySlotData,
  getOrderNameFromOrderId,
  getTimeInHrsMins,
  getCheckSourceIcon,
  getCheckInTime,
  getModeIconBgColor,
  getFormattedOpenOrCloseDate,
} from '@utility/fireboardUtil';
import { setNotification, setErrorPopUp } from '@reducers/notification';
import { cubbySlotAssignApi, newOrderPickedUp, newUpdateOrderStatus } from '@reducers/fireboard';
import { useOutletContext, useNavigate } from 'react-router-dom';
import { LABEL } from '../../veriables';
import { getFormatedPhoneNumber } from '@utility/helperFunction';
import { getPopupConfig } from '@components/common/Popup/index';
import { setCurrentView } from '@reducers/oauth';
import { APP_CONFIG } from '@constants';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const StoreCubby = props => {
  const { tableData, currentMode, setCurrentView, currentView } = props;
  const storeInfo = getObjectValue(() =>
    JSON.parse(window.sessionStorage.getItem('auth'), false)
  );
  const deviceInfo = getObjectValue(() =>
    JSON.parse(window.sessionStorage.getItem('deviceInfo'), false)
  );
  const {
    setIsFlip,
    isFlip,
    setIsExpanded,
    isExpanded,
    handleExpandedRightSection,
    onClickHamburger,
    setTraceClick,
    popup,
    setPopup,
  } = useOutletContext();
  const [sortByName, setSortByName] = useState(false);
  const [showClosedChecks, setShowClosedChecks] = useState(true);
  const [ascendingCheck, setAscendingCheck] = useState(true);
  const [checksForAssignment, setChecksForAssignment] = useState(new Map());
  const [twoDimensionSlot, setTwoDimensionSlot] = useState([[]]);
  const [showCheckDetails, setShowCheckDetails] = useState(false);
  const [selectedCheck, setSelectedCheck] = useState({});
  const [searchFieldValue, setSearchFieldValue] = useState('');
  const checks = useRef(new Map());
  const filteredCheckListItem = useRef([]);
  const currency = LABEL().CURRENCY_SYMBOL;
  const navigate = useNavigate();

  const { supportsTipsOnTotalAmount = false, suppressTipsOnFireBoard = false } =
    storeInfo?.serverAppFeatures || {};

  useEffect(() => {
    setChecks(tableData);
  }, [tableData, searchFieldValue]);

  const setChecks = check => {
    let checkMap = new Map();
    const allChecks = Object.values(check);

    allChecks &&
      allChecks?.forEach(chk => {
        checkMap.set(chk.id, parseCheck(chk));
      });
    checks.current = checkMap;
    refreshCubby();
  };

  const getFilteredChecks = () => {
    const checksArr = Array.from(checks.current.values());
    const filteredCheckList = checksArr?.filter(chk => {
      const { orders } = chk;
      const [order0] = orders || [];

      if (
        chk?.void === true ||
        orders?.length === 0 ||
        order0?.orderStatusId === 10
      ) {
        return false;
      }
      return true;
    });
    return filteredCheckList;
  };

  const refreshCubby = () => {
    const { storeCubby } = storeInfo;
    let filteredChecksList = getFilteredChecks();
    const checks = getFormattedChecks();
    const twoDimensionalSlot = getCubbySlotData(storeCubby, checks);
    setTwoDimensionSlot(twoDimensionalSlot);

    filteredCheckListItem.current = filteredChecksList;
  };

  const getPopup = (type, heading, message) => {
    const popup = type === 'spinner' ? getPopupConfig('spinner') : null;
    if (heading) {
      popup.heading = heading;
    }
    if (message) {
      popup.message = message;
    }
    setPopup(popup);
  };

  const onToggleSwitch = name => {
    if (name === 'nameTimeSort') {
      setSortByName(prev => !prev);
    } else if (name === 'sortByAscDes') {
      setAscendingCheck(prev => !prev);
    } else if (name === 'sortByCloasedAll') {
      setShowClosedChecks(prev => !prev);
    }
  };

  const sortChecksByTime = (a, b) => {
    const time1 = a.pickupTimeInMS;
    const time2 = b.pickupTimeInMS;
    return time1 - time2;
  };

  const pad = (num, size) => {
    let str = String(num);
    while (str.length < (size || 10)) {
      str = '0' + str;
    }
    return str;
  };

  const getDisplayName = item =>
    item.tabName || item.orderDetails?.orderName || item.deliverTo || '';

  const sortChecksByName = (a, b) => {
    const nameA = getDisplayName(a).toLowerCase();
    const nameB = getDisplayName(b).toLowerCase();

    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;
    return 0;
  };

  const getCheckSortFunc = () => {
    const sortFunc = sortByName ? sortChecksByName : sortChecksByTime;
    return sortFunc;
  };

  const getTimeInMilliSeconds = date => {
    if (!date) return 0;
    const convertedDate = date?.includes('Z')
      ? new Date(date)
      : new Date(date + 'Z');
    return convertedDate.getTime();
  };
  const getCheckStatus = check => {
    const statusWithColor = getOrderNameFromOrderId(check);
    return statusWithColor;
  };
  const getModes = check => {
    const { sourceType, tab } = check || {};
    let delivery = false;
    let isMarketPlaceOrder = false;
    let isCatering = false;
    const imgSrc = getCheckSourceIcon(
      sourceType,
      'white',
      delivery,
      isMarketPlaceOrder,
      isCatering,
      tab
    );
    return imgSrc;
  };

  const getModesBgColor = check => {
    const { sourceType, tab } = check || {};
    let delivery = false;
    let isMarketPlaceOrder = false;
    let isCatering = false;
    const bgColor = getModeIconBgColor(
      sourceType,
      delivery,
      isMarketPlaceOrder,
      isCatering,
      tab
    );
    return bgColor;
  };

  const clearSlot = occupiedSlot => {
    const { id: storeId } = storeInfo || {};
    const { name: slotName, checkData } = occupiedSlot || {};
    const { checkHeaderId } = checkData || {};

    const callback = () => {
      const payload = {
        storeId,
        checkHeaderId,
        storeCubbySlotId: null,
      };
      cubbySlotAssignApi(payload, slotName, 'clear');
    };

    const popup = getPopupConfig('success');
    popup.heading = FLABEL().CHECK_CLEAR_SLOT_CONFIRMATION;
    popup.message = FLABEL().CHECK_CLEAR_SLOT_MESSAGE.replace(
      '{{SlotNo}}',
      slotName
    );
    popup.buttons = [
      {
        btnType: 'cancel',
        text: FLABEL().CHECK_NO,
        onClick: () => {
          setPopup(null);
        },
      },
      {
        btnType: 'submit',
        text: FLABEL().CHECK_YES,
        onClick: () => callback(),
      },
    ];
    setPopup(popup);
  };

  const pickedUp = slot => {
    const { id: storeId } = storeInfo || {};
    const payload = {
      checkHeaderId: slot.id,
      deviceId: deviceInfo.deviceId,
      storeId,
    };
    props
      .newOrderPickedUp(payload, 'pickedUp')
      .then(response => {
        props.setNotification({
          type: 'success',
          message: FLABEL().TOAST_ORDER_STATUS,
        });
      })
      .catch(error => {
        props.setErrorPopUp({
          res: error.message,
        });
      });
  };

  const getFormattedChecks = () => {
    const formattedChecks = filteredCheckListItem?.current?.map(check => {
      const [order0] = check?.orders || [];
      const pickupTimeInMS = getElapsedTimeInMs(order0?.pickupDate);
      const dueTimeDisplay = getDueTime(check);
      const AllItems = [
        ...(check?.Items ?? check?.items ?? []),
        ...(check?.PendingItems || []),
      ];
      return {
        ...check,
        AllItems,
        selectedCheckDetails: check,
        checkNumber: check.checkNumber,
        number: check.number,
        id: check.id,
        checkHeaderId: check.checkHeaderId,
        deliverTo: getDeliverTo(check),
        pickupDateInMS: getTimeInMilliSeconds(check.pickupDate),
        status: getCheckStatus(check),
        mode: getModes(check),
        modeBgColor: getModesBgColor(check),
        sourceType: check.sourceType,
        unFormattedPhoneNumber: check.phoneNumber,
        orderStatusId: check.orderStatusId,
        pickupDate: order0.pickupDate,
        pickupTimeInMS: pickupTimeInMS,
        orderDate: check.orderDate,
        openDate: check.openDate,
        orders: check.orders,
        orderTypeId: check.orderTypeId,
        checkName: check.name,
        checkInNote: check.checkInNote,
        unpaidAmount: check.unpaidAmount,
        open: check.open,
        stationId: check.stationId,
        referenceId: check.referenceId,
        taxAmount: check.taxAmount,
        subTotalAmount: check.subTotalAmount,
        totalAmount: check.totalAmount,
        guestName: check.guestName,
        items: check.items,
        tickets: check.tickets,
        seats: check.seats,
        stationName: check.stationName,
        employeeFirstName: check.employeeFirstName,
        employeeLastName: check.employeeLastName,
        dueTime: getTimeInHrsMins(dueTimeDisplay),
        ellapsedTime: check.openDate,
        checkInTime: getCheckInTime(check),
        checkInTimeForSorting: new Date(check.checkInDate).getTime(),
        phoneNumber: check.phoneNumber
          ? getFormatedPhoneNumber(check?.phoneNumber)
          : '- -',
        orderDetails: {
          orderName: check.name,
          phoneNumber: check.phoneNumber
            ? getFormatedPhoneNumber(check?.phoneNumber)
            : '---',
          isPhoneNumber: check.phoneNumber,
        },
        timeDetails: {
          ellapsedTime: check.openDate,
          dueDate: getTimeInHrsMins(dueTimeDisplay),
        },
        tableInfo: {
          tab: check.tab,
          stationName: check.stationName,
          stationNumber: check.stationNumber,
        },
        paymentDetails: {
          paidAmount: check.paidAmount,
          unpaidAmount: check.unpaidAmount,
        },
        openDateDetails: {
          openDate: getFormattedOpenOrCloseDate(check?.openDate),
          closeDate: getFormattedOpenOrCloseDate(check?.closeDate),
          ellapsedTime: check.openDate,
          ellapsedTimeColor: check.openDate,
        },
        guestDetails: {
          guestCount: check?.guestCount,
          phoneNumber: check.phoneNumber
            ? getFormatedPhoneNumber(check?.phoneNumber)
            : '---',
          isPhoneNumber: check.phoneNumber,
          countryCode: check?.orders[0]?.countryCode,
        },
        remainingTimeDetails: {
          remainingTime: check?.pickupDate,
          dueDate: getTimeInHrsMins(dueTimeDisplay),
        },
        storeInfoDetails: {
          storeName: storeInfo?.name,
        },
      };
    });
    return formattedChecks || [];
  };

  const checksRowData = useMemo(() => getFormattedChecks(), [checks.current]);

  const getCheckListItem = useMemo(() => {
    const formattedCheck = checksRowData;
    let checks = [...formattedCheck];

    // serach action on fiterlist
    if (searchFieldValue.trim() !== '') {
      const lowerSearch = searchFieldValue.toLowerCase().trim();
      checks = checks.filter(
        check =>
          check.checkNumber?.toLowerCase().includes(lowerSearch) ||
          check.stationName?.toLowerCase().includes(lowerSearch)
      );
    }

    if (showClosedChecks) {
      checks = checks.filter(check => {
        let openFlag = check?.open === false;

        return openFlag;
      });
    }
    return checks || [];
  }, [checksRowData, showClosedChecks, searchFieldValue]);

  const onSelecteCheckForAssignment = check => {
    if (checksForAssignment.has(check.checkHeaderId)) {
      setChecksForAssignment(new Map());
    } else {
      const checkMap = new Map();
      checkMap.set(check.checkHeaderId, check);
      setChecksForAssignment(checkMap);
    }
  };

  const onSlotAssign = slot => {
    if (checksForAssignment && checksForAssignment.size === 0) {
      props.setErrorPopUp({
        res: 'Select check to assign to this cubby slot',
      });
      return;
    }
    const { id: storeId } = storeInfo || {};
    const checkHeaderIds = [...checksForAssignment.keys()];
    const checkHeaderId = checkHeaderIds[0];
    const { id: storeCubbySlotId, name: slotName } = slot || {};

    const payload = {
      storeId,
      checkHeaderId,
      storeCubbySlotId,
    };
    cubbySlotAssignApi(payload, slotName, 'assign');
  };

  const cubbySlotAssignApi = (payload, slotName, actionType) => {
    getPopup('spinner');
    props
      .cubbySlotAssignApi(payload)
      .then(response => {
        setChecksForAssignment(new Map());
        const messageMap = {
          ['assign']: FLABEL().TOAST_ASSIGN_SLOT.replace(
            '{{SlotNo}}',
            slotName
          ),
          ['move']: FLABEL().TOAST_MOVE_SLOT.replace('{{SlotNo}}', slotName),
          ['clear']: FLABEL().TOAST_CLEAR_SLOT.replace('{{SlotNo}}', slotName),
        };

        props.setNotification({
          type: 'success',
          message: messageMap[actionType],
        });
        const updatedCheck = response;
        checks.current.set(updatedCheck.id, parseCheck(updatedCheck));
        refreshCubby();
        setPopup(null);
      })
      .catch(error => {
        setPopup(null);
        props.setErrorPopUp({
          res: error.message,
        });
      });
  };

  const onMoveSlotOrder = selectedSlots => {
    const { id: storeId } = storeInfo || {};
    const slotIds = [...selectedSlots.keys()];
    const slotId = slotIds[0];
    const slots = [...selectedSlots.values()];
    const [slot0] = slots || [];
    const slotName = slot0?.name || '';
    const payload = {
      storeId,
      checkHeaderId: selectedCheck,
      storeCubbySlotId: slotId,
    };
    cubbySlotAssignApi(payload, slotName, 'move');
  };

  const handleShowCheckDetails = check => {
    setSelectedCheck(check.id);
    setShowCheckDetails(prevState => !prevState);
  };
  const onCloseCheckDetails = () => {
    setShowCheckDetails(false);
  };

  const handleNavigateBack = () => {
    setCurrentView('listView');
    navigate(`${APP_CONFIG.BASE_URL}/fireboard`);
  };

  const checkSortFunc = useMemo(() => {
    return sortByName ? sortChecksByName : sortChecksByTime;
  }, [sortByName]);

  const sortedCheckList = useMemo(() => {
    const sortedChecks = [...getCheckListItem];
    sortedChecks.sort(checkSortFunc);
    if (!ascendingCheck) {
      sortedChecks.reverse();
    }
    return sortedChecks;
  }, [getCheckListItem, checkSortFunc, ascendingCheck]);

  // set 1st check selected by default
  useEffect(() => {
    if (sortedCheckList?.length > 0) {
      const checkMap = new Map();
      checkMap.set(
        sortedCheckList[0].checkHeaderId,
        sortedCheckList[0]
      );
      setChecksForAssignment(checkMap);
    } else {
      setChecksForAssignment(new Map());
    }
  }, [sortedCheckList]);

  const viewProps = useMemo(
    () => ({
      ...props,
      getCheckListItem: sortedCheckList,
      checksRowData,
      ascendingCheck,
      checksForAssignment,
      storeInfo,
      deviceGroup: deviceInfo?.deviceGroup,
      onSelecteCheckForAssignment,
      twoDimensionSlot,
      onSlotAssign,
      showCheckDetails,
      setShowCheckDetails,
      onCloseCheckDetails,
      handleShowCheckDetails,
      selectedCheck,
      setSelectedCheck,
      currentView,
      currency,
      setSearchFieldValue,
      searchFieldValue,
      supportsTipsOnTotalAmount,
      suppressTipsOnFireBoard,
      handleExpandedRightSection,
      pickedUp,
      setIsExpanded,
      isExpanded,
      setTraceClick,
      currentMode,
      setIsFlip,
      isFlip,
      setPopup,
      popup,
      clearSlot,
      onMoveSlotOrder,
      onToggleSwitch,
      sortByName,
      ascendingCheck,
      showClosedChecks,
      checkSortFunc,
      handleNavigateBack,
      onClickHamburger,
    }),
    [
      getCheckListItem,
      checksForAssignment,
      showCheckDetails,
      selectedCheck,
      isExpanded,
      isFlip,
      popup,
      sortByName,
      ascendingCheck,
    ]
  );

  return (
    <div>
      <Views {...viewProps} />
    </div>
  );
};

const mapStateToProps = ({ storeNotifications, storeChecks, oauth }) => ({
  notificationTableData: storeNotifications.storeNotification,
  tableData: { ...storeChecks.checkListHashTable },
  currentMode: oauth.currentMode,
  currentView: oauth.currentView,
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setErrorPopUp,
      cubbySlotAssignApi,
      setNotification,
      newOrderPickedUp,
      setCurrentView,
      newUpdateOrderStatus,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(StoreCubby);
